var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "-10 -12 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2719 0.229535C29.2719 0.229535 32.2321 -0.895893 31.9854 1.83729C31.9032 2.96274 31.1631 6.90173 30.5875 11.1623L28.614 23.7832C28.614 23.7832 28.4496 25.6321 26.9695 25.9537C25.4893 26.2752 23.2692 24.8283 22.858 24.5067C22.5291 24.2656 16.6909 20.6481 14.6351 18.8796C14.0595 18.3972 13.4017 17.4325 14.7173 16.3071L23.3514 8.26837C24.3382 7.30369 25.3249 5.05284 21.2134 7.78603L9.70142 15.4229C9.70142 15.4229 8.38576 16.2267 5.91894 15.5033L0.574035 13.8955C0.574035 13.8955 -1.39946 12.6897 1.97193 11.4838C10.1948 7.70558 20.309 3.84696 29.2719 0.229535Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramWhite);
export default __webpack_public_path__ + "static/media/telegramWhite.70829e593521f1e70bb6b0b67e389740.svg";
export { ForwardRef as ReactComponent };